module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/taluk/taluk.component.css
// module id = ./src/app/masters/taluk/taluk.component.css
// module chunks = main